import { render, staticRenderFns } from "./CenterNews.vue?vue&type=template&id=325854d0&scoped=true"
import script from "./CenterNews.vue?vue&type=script&lang=js"
export * from "./CenterNews.vue?vue&type=script&lang=js"
import style0 from "./CenterNews.vue?vue&type=style&index=0&id=325854d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325854d0",
  null
  
)

export default component.exports